module.exports = __webpack_public_path__ + "static/media/whiteArrowRight.62d6e41c.svg";